//INFO: Archivo remplazado por achivo de cada configuracion de cliente (NO MODIFICAR, NI CREAR)
import { Message } from '../../message';

export const MESSAGES_es_ES_LANG = 'es-ES';
export const MESSAGES_es_ES_explore = 'es-ES_tradnl';

export const MESSAGES_ES = [new Message('', '')];
